import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DailySummaryData } from '../../../../../express-tRPC/src/api/lots/types';

@Component({
  selector: 'syspark-import-sheet-summary',
  templateUrl: './syspark-import-sheet-summary.component.html',
  styleUrl: './syspark-import-sheet-summary.component.scss'
})
export class SysparkImportSheetSummaryComponent {

  @Input() currentLocation!: string;
  @Input() importFileData!: any;

  @Output() saveDailySummaryData = new EventEmitter<any>();
  @Output() clearSheetSeletion = new EventEmitter<string>();

  importSummaryData() {

    const ticketSummaryTableData: any = this.importFileData?.['table'];

    if (ticketSummaryTableData) {
      let dailySummaryData = structuredClone(ticketSummaryTableData['rows']);

      const totalTicketsAmount = dailySummaryData.reduce((sum: number, item: any) => sum + parseFloat(item['Payment'].replace("$", "")), 0);
      const totalTicketsCount = dailySummaryData.length;

      /**
       * We want to store only one entry of total daily cashier summary not each record in DRE
       * So we have pushed an object into dailySummaryData
       */
      dailySummaryData = [
        {
          amount: totalTicketsAmount,
          cashier: this.currentLocation,
          shift: 1, //No shift column found in sheet
          tix_collected: totalTicketsCount,
          stations: '' //No stations column found in sheet
        } as DailySummaryData
      ];
      const importSummaryData = {
        dailySummaryData: dailySummaryData,
        ticketSummaryData: [],
        date: this.importFileData['date']
      };

      this.saveDailySummaryData.emit(importSummaryData);
    }

  }

  clearSummaryData() {
    this.clearSheetSeletion.emit(this.importFileData['date']);
  }
}
